import axios from "axios";

export const createSale = async (sale) => {
    const response = await axios.post(`/api/sales`, { sale });
    return response.data;
};

export const updateSale = async (sale, status) => {
    const response = await axios.put(`/api/sales`, { sale, status });
    return response.data;
};

export const getSale = async id => {
    const response = await axios.get(`/api/sales/${id}`);
    return response.data;
};

export const deleteSale = async id => {
    const response = await axios.delete(`/api/sales/${id}`);
    return response.data;
};
